// health-check.resolver.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { HealthCheckService } from './health-check.service';

export const HealthCheckResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    healthService: HealthCheckService = inject(HealthCheckService)
  ): Observable<any> => {
    return healthService.checkHealth().pipe(
      map(response => ({ status: 'UP', details: response })),
      catchError(error => of({ status: 'DOWN', error: error.message })),
      take(1)
    );
  };